import styled, { createGlobalStyle } from "styled-components";
import { BREAKPOINT_RESERVATION_PAGE } from "./reservationPage/constants/breakpoints";
import { fonts, zIndexes, scrollbars } from "../components/common/mixins";
export { BREAKPOINT_RESERVATION_PAGE } from "./reservationPage/constants/breakpoints";

export const ReservationPageScopedGlobalStyle = createGlobalStyle`
  footer2 {
    display: none !important;
  }

  .public-footer,
  .shopflix-footer,
  .ingr-footer,
  .footer {
    display: none !important;
  }

//move intercom widget under 900px
@media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
    // The launcher is position:fixed inside this position:fixed wrapper. iOS Safari/Android
    // Chrome reposition nested fixed elements late when the toolbar collapses or the page
    // bounces, so the launcher drifts away from the bottom bar. Keep only one fixed layer.
    .intercom-lightweight-app {
      position: static !important;
    }

    // Once the messenger has been opened, Intercom swaps the lightweight app for the full app,
    // whose fixed launcher wrapper only has hashed class names; match it by its iframe instead.
    #intercom-container div:has(> iframe[name="intercom-launcher-frame"]),
    .intercom-lightweight-app-launcher-mobile-up,
    .intercom-lightweight-app-launcher.intercom-launcher {
      bottom: calc(var(--bottom-bar-height, 72px) + 16px) !important;
    }

    .intercom-lightweight-app-launcher-mobile-standar {
         bottom: calc(var(--bottom-bar-height, 72px) + 16px) !important;
    }
  }
  @media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
    .homepage .inner {
      padding: 0;
    }
  }
    @media (max-width: 768px) {
     .homepage .inner.fwr-md-down {
      padding: 0;
    }
  }
`;

export const OlympiacosReservationScopedGlobalStyle = createGlobalStyle`
  #main-wrapper {
    padding: 28px 0 0 0 !important;
  }

  @media (max-width: 768px) {
    #ui-page:has([id$="eventContainer"]) {
      padding-bottom: 0 !important;
    }
  }

  .olympiacos-footer {
    display: none;
  }
`;

export const PageLayout = styled.div`
  display: grid;
  grid-template-columns: repeat(16, 1fr);

  @media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`;

export const PageContainer = styled.div`
  padding-bottom: 120px;
  @media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
    padding: 16px;
    padding-bottom: 120px;
  }
`;

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const LeftColumn = styled.div`
  grid-column: span 8;

  @media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
    order: 2;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const RightColumn = styled.div`
  grid-column: 10 / span 7;
  position: sticky;
  top: 50px;
  align-self: flex-start;

  @media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
    grid-column: 1;
    position: static;
    width: 100%;
    order: 1;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
  gap: 8px;
  align-items: start;

  @media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
    padding-bottom: 0;
    gap: 6px;
  }
`;

export const TotalWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ArrowWrap = styled.button`
  border: none;
  background: transparent;

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const Total = styled.p`
  margin: 0;
  ${fonts.smallTitle()}

  line-height: 24px; /* 150% */
`;

export const SummaryDrawerContent = styled.div`
  background: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow: hidden;
`;

export const SummaryDrawerScrollable = styled.div`
  overflow-y: auto;
  padding: 0 16px 24px 16px;
  flex: 1;
  ${scrollbars.thin()}
`;

export const SummaryDrawerPuller = styled.div`
  width: 48px;
  height: 4px;
  background: #9897a9;
  border-radius: 3px;
  margin: 16px auto 16px;
  flex-shrink: 0;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
    display: none;
  }
`;

export const FixedBottomBar = styled.div`
  display: none;

  @media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 16px calc(16px + env(safe-area-inset-bottom)) 16px;
    background: #fff;
    border-top: 1px solid #d8dbe0;
    z-index: ${zIndexes.fixedBottomBar};
  }
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
    gap: 8px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
